import { useEffect } from 'react';

const SUFFIX = 'MusicVille Academy';

export function usePageTitle(title: string | undefined): void {
  useEffect(() => {
    if (!title) return;
    document.title = title.includes(SUFFIX) ? title : `${title} · ${SUFFIX}`;
  }, [title]);
}
